import { render } from "./CalendarEventAttendeeChooser.vue?vue&type=template&id=43769571&scoped=true"
import script from "./CalendarEventAttendeeChooser.vue?vue&type=script&lang=ts"
export * from "./CalendarEventAttendeeChooser.vue?vue&type=script&lang=ts"

import "./CalendarEventAttendeeChooser.vue?vue&type=style&index=0&id=43769571&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-43769571"

export default script